import api from 'Application/api/api';

const getArchivedEmployeeDocuments = (id, cancelToken = null) =>
    api.get(`/archive/employees/${id}/documents`, {
        cancelToken,
    });

export default getArchivedEmployeeDocuments;
